export default __webpack_public_path__ + "static/media/MelGroundFloor.6a2b8e68.jpg";